import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import Cardconsultaagendamotorista from './cardconsultaagendamotorista';
import {Link} from 'react-router-dom';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';//em transito
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import EventBusyIcon from '@material-ui/icons/EventBusy';//inderefiras
import EventNoteIcon from '@material-ui/icons/EventNote';//analise
import EventIcon from '@material-ui/icons/Event';//concluidas

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   menuButton: {
    //marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    
  },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''


var lotacao='';
var utipo='';
var depnome='';
var iduser= '';
export const  Consultas = withRouter(({history}) => {
   
  const [state, setState] = useState([]);
  var myfila= '';
  
  const[minhafila, setaminhafila]=React.useState('');
 
 
  const[uid, setauid]=React.useState('');
  const[nome, setanome]=React.useState('');
  const[siape, setasiape]=React.useState('');
  const[telefone, setatelefone]=React.useState('');
  const[tipouser, setatipouser]=React.useState('');

var unidadedepartamento='';

var unidadetransporte='';
var campi='';

React.useEffect(() => { // esse é responsável em pegar as alterações
  pegauser()
 },[]);

 var atualuser='';
  async function pegauser() {
    
    const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
      setauid(user.uid)
      iduser=user.uid;
       var userref =  db.collection("usuarios").doc(user.uid);         
       
       await  userref.get().then((doc) => {       
        if (doc.exists) {
         

        
         utipo=doc.data().usertipo;
         setatipouser(utipo);
         setanome(doc.data().nome);
         setasiape(doc.data().siape);
         unidadetransporte=doc.data().codunidadetransporte;
         campi=doc.data().campi;
         setatelefone(doc.data().telefone);

          console.log('porraaaaa' , tipouser);

          
          
       }else{
         alert('Não encontramos o seu cadastro')
       }
      
      }).catch(function(error) {
        alert("Erro ao localizar o seu cadastro ", error.message);
        })
        pegaorgao();
  }

  var depatualuser=[''];
async function pegaorgao(){
  console.log("campi ", unidadedepartamento);
 if ((unidadetransporte!='')&&(unidadetransporte!=undefined)) {
        
  console.log("unitrans v ", unidadetransporte);
 var db3 = firebase.firestore();
  var userref =  db3.collection("unidadetransporte").doc(unidadetransporte);         
  await userref.get().then((doc) => {       
    var tempdepsol;
    if (doc.exists) {
     var tempdepsol=[];
    tempdepsol.push({tipodepsolicitante: 'unidadetransporte',codunidadetransporte:unidadetransporte, 
    nomecentroadm: doc.data().nomeunidadetransporte
    })
      depatualuser= tempdepsol;
      myfila=unidadetransporte;
      setaminhafila(myfila);
      console.log("unitrans001 ", myfila);
      pegalista()
        }else{
    alert('Não encontramos a unidade que você está vinculado')
  }}).catch(function(error) {
   alert("Erro ao localizar o seu cadastro001 ", error.message);
   })

      }
      
    }
    
  
  
 


async function pegalista() {          
   
      //alert(iduser);
      var db = firebase.firestore();
      var query = await db.collection("agenda").where("motorista.id", "==", iduser).
      where('status','==', 'deferido').orderBy('datahorasaida').get()
      .then(function(querySnapshot) {
      
       querySnapshot.forEach(function(doc) {
         var listausers=[];
           listausers.push({id: doc.id, datahoraretorno: doc.data().datahoraretorno,observacao:doc.data().observacao,anexo:doc.data().anexo,kminicio: doc.data().kminicio,
            datahorasaida:doc.data().datahorasaida, dsolicitacao: doc.data().dsolicitacao,campisolicitante:doc.data().campisolicitante,valorkmrodado:doc.data().valorkmrodado,
            listapassageiros: doc.data().listapassageiros, depsolicitacao: doc.data().depsolicitacao, nomesolicitante: doc.data().nomesolicitante, idsolicitante:doc.data().idsolicitante,
            npassageiro: doc.data().npassageiro, nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo,totalkm: doc.data().kilometragem, status:doc.data().status,temporetorno:doc.data().temporetorno,
            siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadasida: doc.data().listaparadasida,listaparadasvolta: doc.data().listaparadasvolta,
            localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipodeslocamento:doc.data().tipodeslocamento, nomerespdespesas:doc.data().nomerespdespesas,statuschecklist:doc.data().statuschecklist,
            fonerespdespesas:doc.data().fonerespdespesas, respdespesas:doc.data().respdespesas,autorizacoes:doc.data().autorizacoes, veiculo: doc.data().veiculo, motorista: doc.data().motorista,
          });
         console.log("agenda ", state );
        setState (currentArray => [...currentArray, listausers]);
        

       });
      
     })
    .catch(error => {
        console.log('Não encontramos veículos cadastrados', error);
    });
    
    
   
         
       
        
    
  }

  //*****************************************************controle botões solicitações */
  /*
function handlerandamento(){
  history.push('/Consultarandamento');  
}
/*
function handleraprovadas(){
  history.push('/Consultaraprovada');  
}

function handlerrealizadas(){
  history.push('/ConsultarRealizadas');  
}*/
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Solicitações
          </Typography>
        
      <div id="corpo"   align="center" className={classes.paper} >

         <div id="corpoveiculo">

         <Container maxWidth="xs">
             <Grid container spacing={1}>
            
              {console.log('tamanho da lista=> ', myfila)}
             {state.map(item=>(
              <Grid item key={item.id } xs={12} >
                <Cardconsultaagendamotorista pagina={1} user={uid} myfila={minhafila} usertipo={tipouser} usernome={nome} usersiape={siape} usertelefone={telefone} props={item} key={item.id} />
                 </Grid>
               //console.log('tamanho da lista11111=> ', item)
               
             ))}
             </Grid>

            
             </Container>
           </div>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Consultas;
